import { BaseModel } from "@/models/base.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { WorkPeriodTemplateActivity } from "@/models/work-period-template-activity.model.ts"
import type { IWorkPeriodTemplate } from "@/interfaces/api/work-period-template.interface.ts"
import type { Moment } from "moment"

export class WorkPeriodTemplate extends BaseModel implements IWorkPeriodTemplate {
  public static className = "WorkPeriodTemplate" // Used for socket communication.
  public static verboseName = "dienst-template"

  public static override managedResolveFields = ["owner"]

  owner: KnownBusinessEntityContact
  activities: WorkPeriodTemplateActivity[]

  title?: string | null
  timeStart: Moment
  timeEnd?: Moment | null
  description: string

  constructor(template: IWorkPeriodTemplate, managed = false) {
    super(template)

    this.owner = ModelFactory.childModel(KnownBusinessEntityContact, template.owner, managed)
    this.activities = ModelFactory.childModels(
      WorkPeriodTemplateActivity,
      template.activities,
      managed
    )

    this.title = template.title
    this.timeStart = template.timeStart
    this.timeEnd = template.timeEnd
    this.description = template.description
  }
}
